import { useMemo } from 'react';
import { queryClient } from '@alfa-bank/newclick-global';
import { getQueryKeyFromApiMethod } from '../../utils/react-query/get-query-key-from-api-method';
import { useDeepMemo } from '../use-deep-memo';
/**
 * Хук, возвраающий данные из кеширующего провайдера, принимая apiMethod
 */
export const useCachedData = (apiMethod, options) => {
    const defaultFetchParams = useDeepMemo(options?.params);
    const queryKey = useMemo(() => getQueryKeyFromApiMethod(apiMethod, defaultFetchParams), [apiMethod, defaultFetchParams]);
    const responseFromCache = useMemo(() => queryClient.getQueryData(queryKey), [queryKey]);
    return responseFromCache?.data;
};
